import { DragHandle, Lock, LockOpen } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";

var favouriteCoordinates: Map<
  number,
  { x: number; top: number; bottom: number }
> = new Map();

const SoundButton = ({
  soundName,
  buttonWidth,
  clickFunction,
  rightClickFunction,
  dragEnabled,
  onDrag = () => {},
  onDragEnd = () => {},
}: {
  soundName: string;
  buttonWidth: number;
  clickFunction: (s: string) => void;
  rightClickFunction: (e: any) => void;
  dragEnabled: boolean;
  onDrag?: (e: any) => void;
  onDragEnd?: (e: any) => void;
}) => {
  return (
    <Box
      sx={{ zIndex: 50, display: "flex" }}
      onDrag={dragEnabled ? onDrag : (e) => e.preventDefault()}
      onDragEnd={dragEnabled ? onDragEnd : (e) => e.preventDefault()}
      draggable={dragEnabled}
    >
      {dragEnabled && (
        <DragHandle
          sx={{
            background: "rgb(74, 74, 74)",
            border: "1px solid grey",
            color: "grey",
            zIndex: 2,
            width: "1em",
            height: "1em",
            position: "absolute",
            borderRadius: "6px",
          }}
        />
      )}
      <Button
        type="button"
        sx={{
          width: `${buttonWidth}ch`,
          color: "white",
          border: "1px solid black",
          borderRadius: "12px",
          backgroundColor: "rgb(74, 74, 74)",
          height: "4em",
          textTransform: "none",
          margin: "2px",
          zIndex: 0,
          "&:hover": {
            border: `2px solid gold`,
            backgroundColor: "rgb(74, 74, 74)",
          },
        }}
        fullWidth
        id={soundName}
        key={soundName}
        variant="outlined"
        size="medium"
        onClick={() => clickFunction(soundName)}
        onContextMenu={rightClickFunction}
      >
        {soundName}
      </Button>
    </Box>
  );
};

export const Favourites = ({
  clickFunction,
  rightClickFunction,
}: {
  clickFunction: (s: string) => void;
  rightClickFunction: (e: any) => void;
}) => {
  useEffect(() => {
    document.ondragover = (e) => e.preventDefault();
  }, []); // disable drop animation

  const [dragEnabled, setDragEnabled] = useState(false);
  const [dragIndex, setDragIndex] = useState(-1);

  const favourites = JSON.parse(
    localStorage.getItem("HegBot-SoundBoard-Favourites") ?? "[]"
  ) as string[];

  const buttonWidth = Math.max(...favourites.map((i) => i.length), 17) + 1;

  const moveFavourite = (e: any) => {
    const sound = e.target.textContent;
    console.log({
      sound,
      favourites,
    });
    var faves = [...favourites.filter((it) => it !== sound)];
    faves.splice(
      dragIndex < favourites.indexOf(sound) ? dragIndex : dragIndex - 1,
      0,
      sound
    );
    console.log(faves);
    localStorage.setItem("HegBot-SoundBoard-Favourites", JSON.stringify(faves));
    setDragIndex(-1);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
          marginX: "0.5em",
          marginTop: "1em",
        }}
      >
        &#11088; Favourites
        {dragEnabled ? (
          <LockOpen onClick={() => setDragEnabled(false)} />
        ) : (
          <Lock onClick={() => setDragEnabled(true)} />
        )}
      </Box>
      <hr />
      <p>
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          {favourites.map((soundName, index) => (
            <Box
              style={{
                borderLeft: index === dragIndex ? "2px solid gold" : "none",
                borderRight:
                  index === favouriteCoordinates.size - 1 && dragIndex > index
                    ? "2px solid gold"
                    : "none",
              }}
              ref={(e: any) => {
                if (e) {
                  const rect = e.getBoundingClientRect();
                  favouriteCoordinates.set(index, {
                    x: rect.x + rect.width / 2,
                    top: rect.top,
                    bottom: rect.bottom,
                  });
                } else {
                  favouriteCoordinates.delete(index);
                }
              }}
            >
              <SoundButton
                soundName={soundName}
                buttonWidth={buttonWidth}
                clickFunction={clickFunction}
                rightClickFunction={rightClickFunction}
                dragEnabled={dragEnabled}
                onDrag={(e) => {
                  setDragIndex(
                    [...favouriteCoordinates.values()].filter(
                      (coords) =>
                        coords.bottom < (e.clientY ?? -1) ||
                        (coords.top < (e.clientY ?? -1) && coords.x < e.clientX)
                    ).length
                  );
                }}
                onDragEnd={moveFavourite}
              />
            </Box>
          ))}
        </Box>
      </p>
    </>
  );
};
